import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  BackendService,
  HttpOptions,
  PaginatedResponseModel,
} from '@ipg/ngx-frontend-toolset';
import { InteractionSession } from '../../../models/interactions.model';

@Injectable({
  providedIn: 'root',
})
export class InteractionSessionService {
  private _backend = inject(BackendService);

  getAll(
    clientId: string,
    options?: HttpOptions
  ): Observable<PaginatedResponseModel<InteractionSession[]>> {
    return this._backend.get(`/clients/${clientId}/interaction-history`, options);
  }
}
